
require('./date-repeater');
require('./request-trainee-form');
require('./add-trainee-form');
require('./authorisations');
require('./custom-registration');

import Cookies from 'js-cookie';

$(() => {
  $('.clickable-row').on('click', function(e) {
    e.stopPropagation();
    if ($(this).data('target')) {
      window.open($(this).data('href'), $(this).data('target'));
      return;
    }
    window.location = $(this).data('href');
  });

  const form = $('#attestationClientForm');

  $('#attestationClientFormSubmit').on('click', function(ev) {
    ev.preventDefault();
    const expires       = $('#expires').val();
    const training_ids  = $('#training_ids').val();
    
    form.find('input[name="expires"]').val(expires);
    form.find('input[name="training_ids"]').val(training_ids);
    form.trigger('submit');
  });

  const table = $('#attestationClientTable');

  $('#attestationClient_selectNone').on('click', function() {
    $('td input:checkbox',table).prop('checked', false);
  });

  $('#attestationClient_selectAll').on('click', function() {
    $('td input:checkbox',table).prop('checked', true);
  });

  setTimeout(() => {
    const isOldUser = $('#digitalTraining').attr('data-is-old-user');
    const hasSeenModal = Cookies.get('digitalTrainingSeen')
  
    if (isOldUser === 'true' && !hasSeenModal) {
      Cookies.set('digitalTrainingSeen', 'true', { expires: 30 });
      $('#digitalTraining').modal('show');
    }
  }, 5000);

  $('#AssignModal').on('show.bs.modal', function() {

    let selectedTrainees = $('#trainee_id').val();
    let target =  $('#target_at').val();
    const selectedType = $('input[name="type"]:checked').val();

    $('#trainee_id_modal').val(selectedTrainees);
    $('#target_at_modal').val(target);
    $('#type_modal').val(selectedType);
  });

  $('#addTraineeEmail').on('click', function() {
    const url = $(this).data('url');
    $('#addEmailForm').attr('action', url);
  });

  $('#multiArchiveBtn').on('click', async function() {
    const selectedCertificates = [];

    $('.certificate-checkbox:checked').each(function () {
      selectedCertificates.push({
        certificate_id: $(this).val(),
        trainee_id: $(this).data('trainee-id')
      });
    });

    if (selectedCertificates.length) {

      $.ajax({
        url: $(this).data('url'),
        method: 'POST',
        data: JSON.stringify({ certificate_ids: selectedCertificates }),
        contentType: 'application/json',
        success: (res) => {
          window.location.reload();
        },
        error: function (err) {
          alert("Une erreur est survenue lors de l'archivage.");
        }
      });
    }
  });

  // Show/hide the trainee select based on the radio button
  function toggleSelectDisabled() {
    const allUsersRadio = document.getElementById('all_users');
    const specificUsersRadio = document.getElementById('specific_users');
    const traineeSelect = document.getElementById('trainee_id');

    if (allUsersRadio && specificUsersRadio && traineeSelect) {
      if (allUsersRadio.checked) {
        traineeSelect.setAttribute('disabled', 'true');
      } else {
        traineeSelect.removeAttribute('disabled');
      }

      allUsersRadio.addEventListener('change', toggleSelectDisabled);
      specificUsersRadio.addEventListener('change', toggleSelectDisabled);
    }
  }

  toggleSelectDisabled();
});
